export enum EstadoProyectoEnum {
    INITIALIZING = "INITIALIZING",
    READY_TO_GET_STATISTICS = "READY_TO_GET_STATISTICS",
    CALCULATING_STATISTICS = "CALCULATING_STATISTICS",
    ERROR_INITIALIZING = "ERROR_INITIALIZING",
    EMPTY_DATAFRAMES = "EMPTY_DATAFRAMES",
    DATA_FILTERING = "DATA_FILTERING",
    FILTERS_APPLIED = "FILTERS_APPLIED",
    NORMALIZING_DATASETS = "NORMALIZING_DATASETS",
    DATASETS_NORMALIZED = "DATASETS_NORMALIZED",
    CREATING_IN_BIGML = "CREATING_IN_BIGML",
    CREATED_IN_BIGML = "CREATED_IN_BIGML",
    READY_TO_START = "READY_TO_START",
    RUNNING = "RUNNING",
    PREDICTING = "PREDICTING",
    PAUSED = "PAUSED",
    FINISHED = "FINISHED",
    STOPPED = "STOPPED"
}
